
export type AuthMode = 'external' | 'legacy'

export const AUTH_MODE: AuthMode = import.meta.env.VITE_AUTH_MODE || 'legacy'
export const EXTERNAL_IDP_LOGIN_URL: string = import.meta.env.VITE_EXTERNAL_IDP_LOGIN_URL
export const GOOGLE_INTEGRATION_URL: string | null = import.meta.env.VITE_GOOGLE_INTEGRATION_URL
export const PIPEDRIVE_INTEGRATIONS_BASE_URL: string | null = import.meta.env.VITE_PIPEDRIVE_INTEGRATIONS_BASE_URL
export const SALESFORCE_PROXY_MODE: boolean = import.meta.env.VITE_SALESFORCE_PROXY_MODE === 'true'
export const GRAPHQL_API_URL: string = import.meta.env.VITE_GRAPHQL_API_URL
export const EXTERNAL_REFRESH_URL: string = import.meta.env.VITE_EXTERNAL_REFRESH_URL
export const MAIN_PRODUCT_URL: string = import.meta.env.VITE_MAIN_PRODUCT_URL || 'https://account.leadiq.com'
